'use strict';

module.exports = function(element) {
	var siteURL = 'https://sarcadass.github.io/granim.js/api.html';
	throw new Error('Granim: Input error on "' + element + '" option.\nCheck the API ' + siteURL + '.');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/triggerError.js
// module id = aP1u
// module chunks = 0 1 2 6